import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";

// IMAGES
import logo from "../../img/logo.png";

// COMPONENTS
import SignIn from "../elements/Signin";
import SignUp from "../elements/Signup";

export default class TopNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen: false,
            scrolled: false,
        };
        this.openMenu = this.openMenu.bind(this);
    }
    openMenu = () => {
        this.setState((prevState) => {
            return { isMenuOpen: !prevState.isMenuOpen };
        });
    };

    componentDidMount() {
        window.addEventListener("scroll", () => {
            const isTop = window.scrollY < 100;
            if (isTop !== true) {
                this.setState({ scrolled: true });
            } else {
                this.setState({ scrolled: false });
            }
        });
    }

    componentWillUnmount() {
        window.removeEventListener("scroll");
    }

    render() {
        return (
            <>
                <div
                    className={
                        this.state.scrolled ? "top-nav scrolled" : "top-nav"
                    }
                >
                    <div className="top-nav__container">
                        <div className="custom-container">
                            <header>
                                <div className="header-wrapper">
                                    <div className="logo-wrap">
                                        <Link
                                            className="hover-target animsition-link"
                                            href="home"
                                            to={"/"}
                                        >
                                            <img src={logo} alt="" />
                                        </Link>
                                    </div>
                                    <div className="nav-button-wrap">
                                        <div className="nav-log-wrapper">
                                            <SignIn />
                                            <SignUp />
                                        </div>
                                        <div
                                            className={
                                                this.state.isMenuOpen
                                                    ? "nav-active nav-but-wrap"
                                                    : "nav-but-wrap"
                                            }
                                        >
                                            <div
                                                onClick={this.openMenu}
                                                className="menu-icon"
                                            >
                                                <span className="menu-icon__line menu-icon__line-left"></span>
                                                <span className="menu-icon__line"></span>
                                                <span className="menu-icon__line menu-icon__line-right"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </header>
                        </div>
                    </div>
                </div>
                <div className={this.state.isMenuOpen ? "nav-active" : ""}>
                    <div className="nav">
                        <div className="nav__content">
                            <ul className="nav__list">
                                <li className="nav__list-item">
                                    <NavLink
                                        href="home"
                                        to={"/"}
                                        className="hover-target animsition-link"
                                        onClick={this.openMenu}
                                    >
                                        Home
                                    </NavLink>
                                </li>
                                <li className="nav__list-item">
                                    <NavLink
                                        href="service"
                                        to={"/service"}
                                        className="hover-target animsition-link"
                                        onClick={this.openMenu}
                                        activeClassName="active-nav"
                                    >
                                        Our Services
                                    </NavLink>
                                </li>
                                <li className="nav__list-item">
                                    <NavLink
                                        href="portfolio"
                                        to={"/portfolio"}
                                        className="hover-target animsition-link"
                                        onClick={this.openMenu}
                                        activeClassName="active-nav"
                                    >
                                        Portfolio
                                    </NavLink>
                                </li>
                                <li className="nav__list-item">
                                    <NavLink
                                        href="about"
                                        to={"/about"}
                                        className="hover-target animsition-link"
                                        onClick={this.openMenu}
                                        activeClassName="active-nav"
                                    >
                                        About Us
                                    </NavLink>
                                </li>
                                <li className="nav__list-item">
                                    <NavLink
                                        href="blog"
                                        to={"/blog"}
                                        className="hover-target animsition-link"
                                        onClick={this.openMenu}
                                        activeClassName="active-nav"
                                    >
                                        Blog
                                    </NavLink>
                                </li>
                                <li className="nav__list-item">
                                    <NavLink
                                        href="contact"
                                        to={"/contact"}
                                        className="hover-target animsition-link"
                                        onClick={this.openMenu}
                                        activeClassName="active-nav"
                                    >
                                        Contact
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
